import { useTranslation } from 'react-i18next';

import { useCurrentOrganizationName } from '../api/user.selectors';

/**
 * The current organization's name, ready to drop into a sentence.
 *
 * `useCurrentOrganizationName` answers `undefined` until sign-in resolves, and a blank in the
 * middle of running copy reads as a bug.
 */
export function useOrganizationDisplayName(): string {
  const { t } = useTranslation('common');
  return useCurrentOrganizationName() ?? t('hooks.useOrganizationDisplayName.thisOrganization');
}
